import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import styled from 'styled-components';
import {
  AlertHistoryMetaPanel,
  AlertHistoryMetaPanelTitle,
  AlertsCountLabel,
  CountDescriptionLabel,
  FlexWrapper,
  MetaDataBox,
  MetaDataWrapper,
  SarsCountLabel,
  ViewTypologiesLink
} from './styled';
import TypologiesModal from '../TypologiesModal';
import moment from 'moment';
import { SMART_ASSESSMENT_SOURCE_IDS } from './constants';
import { DEFAULT_PAGE_SIZE } from '../../constants/cmConstants';
import { convertDateInputToEpoch } from '../../../util/timezone';
import Wait4Me from '../../../components/Wait4Me';

import { isEmpty } from '../../../util/lodashlike';
const AlertHistoryMeta = ({
  alertId,
  alertCounts,
  isLoading,
  customerId,
  apiActions,
  getCustomerID
}) => {
  const [showTypologies, setShowTypologies] = useState(false);

  const toggleTypologiesModal = () => {
    setShowTypologies(!showTypologies);
  };

  const { getAMLSCommonUnifiedAlertCounts } = apiActions;
  const { alertRaised, sars } = alertCounts || {};

  useEffect(() => {
    getCustomerID(customerId);
  }, [customerId]);

  useEffect(() => {
    if (!isEmpty(customerId)) {
      getAMLSCommonUnifiedAlertCounts({
        customerId: `${customerId},`,
        sourceIds: SMART_ASSESSMENT_SOURCE_IDS.join(','),
        limit: DEFAULT_PAGE_SIZE,
        offset: 0,
        q: 'eyJzb3J0Ijp7fSwiZmlsdGVyIjpbXX0K',
        from: convertDateInputToEpoch(
          moment().subtract(30, 'days').add(1, 'days'),
          true
        ),
        to: convertDateInputToEpoch(moment(), true)
      });
    }
  }, [customerId]);

  return (
    <>
      <AlertHistoryMetaPanel>
        <AlertHistoryMetaPanelTitle>Alert History</AlertHistoryMetaPanelTitle>
        <MetaDataWrapper gutter={[20, 0]}>
          {isLoading ? (
            <LoadingWrapper>
              <Wait4Me />
            </LoadingWrapper>
          ) : (
            <>
              <Col span={12}>
                <MetaDataBox>
                  <AlertsCountLabel>{alertRaised || 0}</AlertsCountLabel>
                  <CountDescriptionLabel>Alert Raised</CountDescriptionLabel>
                </MetaDataBox>
              </Col>
              <Col span={12}>
                <MetaDataBox>
                  <SarsCountLabel>{sars || 0}</SarsCountLabel>
                  <FlexWrapper>
                    <CountDescriptionLabel>SARs</CountDescriptionLabel>
                    <ViewTypologiesLink
                      disabled={!sars}
                      style={!sars ? { cursor: 'not-allowed' } : null}
                      onClick={toggleTypologiesModal}>
                      View Typologies
                    </ViewTypologiesLink>
                  </FlexWrapper>
                </MetaDataBox>
              </Col>
            </>
          )}
        </MetaDataWrapper>
      </AlertHistoryMetaPanel>
      {showTypologies && (
        <TypologiesModal onToggle={toggleTypologiesModal} alertId={alertId} />
      )}
    </>
  );
};

const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
`;

AlertHistoryMeta.propTypes = {
  apiActions: PropTypes.object.isRequired,
  alertId: PropTypes.string.isRequired,
  alertCounts: PropTypes.object,
  isLoading: PropTypes.bool,
  customerId: PropTypes.string
};

export default AlertHistoryMeta;
